export const CLIENT_PAGES = {
	HOMEPAGE: 'HOMEPAGE',
	LOGIN: 'LOGIN',
	PRODUCTS_TYPE: 'PRODUCTS_TYPE',
	PRODUCTS: 'PRODUCTS',
	PRODUCTS_DETAILS: 'PRODUCTS_DETAILS',
	CUSTOMERS: 'CUSTOMERS',
	ORDERS: 'ORDERS',
	ADMIN: 'ADMINAREA',
};

export const CLIENT_ROUTES = [
	{
		displayName: 'Homepage',
		name: CLIENT_PAGES.HOMEPAGE,
		needAuthentication: true,
		path: '/',
	},
	{
		displayName: 'Admin Area',
		name: CLIENT_PAGES.ADMIN,
		needAuthentication: true,
		path: '/admin',
	},
	{
		displayName: 'Login',
		name: CLIENT_PAGES.LOGIN,
		needAuthentication: false,
		path: '/login',
	},
	{
		displayName: 'Products Type',
		name: CLIENT_PAGES.PRODUCTS_TYPE,
		needAuthentication: true,
		path: '/catalog',
	},
	{
		displayName: 'Products',
		name: CLIENT_PAGES.PRODUCTS,
		needAuthentication: true,
		path: '/catalog/:businessUnitCode',
	},
	{
		displayName: 'Products Detail',
		name: CLIENT_PAGES.PRODUCTS_DETAILS,
		needAuthentication: true,
		path: '/catalog/:businessUnitCode/:productId',
	},
	{
		displayName: 'Customers',
		name: CLIENT_PAGES.CUSTOMERS,
		needAuthentication: true,
		path: '/customers',
	},
	{
		displayName: 'Orders',
		name: CLIENT_PAGES.ORDERS,
		needAuthentication: true,
		path: '/orders',
	},
];
